<template>
  <div>
    <el-table :data="loginLogs" tooltip-effect="dark" border stripe height="calc(100vh - 155px)" v-loading="loading">
      <el-table-column v-for="(column, index) in tableColumns" :key="index" :type="column.type" :prop="column.prop"
        :label="column.label" :width="column.width" :min-width="column.minWidth" :formatter="column.formatter"
        :fixed="column.fixed" :show-overflow-tooltip="column.tooltip">
      </el-table-column>
    </el-table>

    <el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="total"
      :current-page="params.pageNo" :page-size="params.length" @current-change="pageNoChange"
      @size-change="lengthChange" style="margin-top: 15px;">
    </el-pagination>
  </div>
</template>

<script>
import { getUserLoginLogByUserId } from '@/api/sys/user'
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    userId: String,
    currColumnValue: Number
  },
  data() {
    return {
      loading: false,
      total: 0,
      loginLogs: [],
      tableColumns: [
        { type: 'index', width: 55, label: '序号', fixed: 'left' },
        { prop: 'optTimeString', label: '时间' },
        { prop: 'optIp', label: 'IP' },
        { prop: 'optTypeName', label: '操作类型' }
      ],
      params: {
        userId: null,
        pageNo: 1,
        length: 20
      }
    };
  },
  methods: {
    getData() {
      this.loading = true;
      getUserLoginLogByUserId(this.params).then(({data}) => {
        this.loginLogs = data.data;
        this.total = data.page.totalRecords;
        this.loading = false;
      }).catch(_ => this.loading = false);
    },
    searchData() {
      this.params.pageNo = 1;
      this.getData();
    },
    pageNoChange(pageNo) {
      this.params.pageNo = pageNo;
      this.getData();
    },
    lengthChange(length) {
      this.params.length = length;
      this.searchData();
    }
  },
  watch: {
    currColumnValue(val) {
      if (val === 4) {
        this.params.userId = this.userId;
        this.getData();
      }
    }
  }
})
</script>
